module.exports = __webpack_public_path__ + "static/img/help.c862499a.svg";